module.exports = __webpack_public_path__ + "static/img/user.7f16b85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/user.png
// module id = TlOy
// module chunks = 2